import { useAuth, useOrganization } from '@clerk/clerk-react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { billingKeys } from '@/lib/queryKeys'
import { updateBillingAddon } from '../api/api'
import type { AddonChangeRequest } from '../types'

/** Previews (`confirm: false`) or writes an add-on change for the session's
 *  organization. Only a confirmed change refetches the billing page, including
 *  one that failed, since it may have landed; a preview changes nothing. */
export function useUpdateBillingAddonMutation() {
  const { getToken } = useAuth()
  const { organization } = useOrganization()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: AddonChangeRequest) => {
      const token = await getToken()
      if (!token) throw new Error('Not authenticated')
      return updateBillingAddon(token, body)
    },
    onSettled: (_result, _error, body) => {
      if (!body.confirm || !organization) return
      return queryClient.invalidateQueries({
        queryKey: billingKeys.all(organization.id),
      })
    },
  })
}
